<div class="auth-shell">
  <div class="auth-card">
    <section class="brand-panel">
      <div class="brand-mark">
        <span class="brand-logo" aria-hidden="true">
          <img [src]="brand.logoPath" alt="" />
        </span>
        <span class="brand-name">{{ brand.name }}</span>
      </div>
      <h1>Create a new secure password</h1>
      <p>
        Set a fresh password for your account. Make sure it is at least 8 characters
        and different from your last one.
      </p>
      <div class="feature-list">
        <div class="feature">
          <mat-icon>lock_reset</mat-icon>
          <span>Fast secure reset</span>
        </div>
        <div class="feature">
          <mat-icon>verified_user</mat-icon>
          <span>Account protection built in</span>
        </div>
        <div class="feature">
          <mat-icon>shield</mat-icon>
          <span>Security-first access</span>
        </div>
      </div>
    </section>

    <section class="form-panel">
      <mat-card class="form-card">
        <mat-card-header>
          <mat-card-title>Reset password</mat-card-title>
          <mat-card-subtitle>Enter the reset token and your new password.</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <form class="form-grid" [formGroup]="resetForm" (ngSubmit)="onSubmit()">
            <input type="hidden" formControlName="token" />

            <mat-form-field appearance="outline">
              <mat-label>New password</mat-label>
              <input
                matInput
                type="password"
                formControlName="password"
                placeholder="Minimum 8 characters"
              />
              @if(resetForm.get('password')?.hasError('required')){
              <mat-error>Password is required.</mat-error>
              }
              @if(resetForm.get('password')?.hasError('minlength')){
              <mat-error>Use at least 8 characters.</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Confirm password</mat-label>
              <input
                matInput
                type="password"
                formControlName="confirmPassword"
                placeholder="Re-enter your password"
              />
              @if(resetForm.get('confirmPassword')?.hasError('required')){
              <mat-error>Confirm your password.</mat-error>
              }
              @if(resetForm.get('confirmPassword')?.hasError('passwordMismatch')){
              <mat-error>Passwords do not match.</mat-error>
              }
            </mat-form-field>

            @if(validationError()){
            <app-validation-error [errors]="validationError()"></app-validation-error>
            }

            <div class="form-actions">
              <button mat-raised-button color="primary" type="submit">Update password</button>
              <button mat-button type="button" routerLink="/auth/login">Back to login</button>
            </div>
          </form>
          <mat-divider class="section-divider"></mat-divider>
          <!-- <div class="footer-actions">
            <span>Need an account?</span>
            <button mat-button type="button" routerLink="/auth/register">Create account</button>
          </div> -->
        </mat-card-content>
      </mat-card>
    </section>
  </div>
</div>
